<script>

	export let poster;
	export let src;

</script>

<div>
	<video
		poster="{poster}"
		src="{src}"
		loading="lazy"
		type="video/mp4"
		controls>
	
	<track kind="captions">
	</video>
</div>

<style>
	div {
		position: relative;
	}

	video {
		width: 100%;
	}
</style>